import { OnInit, Component, Input } from '@angular/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { TurnoUACModel } from 'src/app/models/turnoUAC.model';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { TransferirTurnoUACComponent } from './transferir-turno-UAC.component';

@Component({
    selector: 'app-atencion-ciudadano',
    templateUrl: './atencion-ciudadano-UAC.component.html',
    styleUrls: ['./atender-ciudadano-UAC.component.scss']
})

export class AtencionCiudadanoUACComponent implements OnInit {

    @Input() public turno: TurnoUACModel;
    @Input() listaTramites: any[];
    @Input() tramiteActual: any;

    public correoInvalido: boolean;
    public modalOptions: ConfirmationModalOptions;


    constructor(
        public alertService: AlertService,
        private activeModal: NgbActiveModal,
        private modalService: NgbModal) {
        this.correoInvalido = false;
        this.modalOptions = new ConfirmationModalOptions('Confirmaciòn'
            , '¿Está seguro de finalizar atención?', 'SI', 'NO', 'fas fa-flag-checkered', false, null
            , 'Finalizar Atención', null, 'btn btn-secondary btn-block');

    }
    ngOnInit() {

    }

    close() {
        this.activeModal.close();
    }

    /**
     * mètodo que devuelve el objeto de turno al componente padre para guardar la finalizaciòn
     * @author fromero
     */
    finalizarAtencionTurno(event?: any) {

        if (event[0]) {
            if ((!this.turno.correoVisitante || this.turno.correoVisitante == '') && this.turno.requiereCertificado) {
                this.alertService.generateAlertError(
                    'Se debe diligenciar dirección de correo electrónico para enviar certificado de atención', 'Error');
            } else {
                this.activeModal.close(this.turno);
            }
        }
    }

    /**
     * acciòn de trasnferencia de turno
     * @author fromero
     */
    transferirTramiteTurno() {
        const modalRef = this.modalService.open(TransferirTurnoUACComponent, { centered: true, size: 'sm' });
        modalRef.componentInstance.turno = this.turno; // Objeto que se envìa al modal para ediciòn
        modalRef.componentInstance.listaTramites = this.listaTramites;
        modalRef.componentInstance.tramiteActual = this.tramiteActual;

        modalRef.result.then(result => {
            if (result) {
                this.activeModal.close();
            }
        });
    }


    /**
     * mètodo para validar el correo electrònico
     * @author fromero
     */
    validarCorreo() {
        const regex = /^(([^<>()[\]\.,;:\s@\']+(\.[^<>()[\]\.,;:\s@\']+)*)|(\'.+\'))@(([^<>()[\]\.,;:\s@\']+\.)+[^<>()[\]\.,;:\s@\']{2,})$/i;

        if (this.turno.correoVisitante !== '' && this.turno.correoVisitante) {
            const reps = regex.test(this.turno.correoVisitante);
            this.correoInvalido = !reps;
            this.modalOptions.disabled = !reps;
            return reps;
        } else {
            this.correoInvalido = false;
            return true;
        }
    }
}
